import React from 'react';
import { Checkbox, CheckboxProps } from '@mui/material';
import { colors } from 'crono-fe-common/theme';
import IconUnchecked from 'crono-fe-common/icons/Icon-Unchecked';
import IconIndeterminate from 'crono-fe-common/icons/Icon-Indeterminate';
import IconChecked from 'crono-fe-common/icons/Icon-Checked';
import styled from '@emotion/styled';

/**
 * @deprecated Use `Checkbox` from `@crono-one/design-system` instead.
 */
const CronoCheckbox = ({ sx, disabled, ...props }: CheckboxProps) => {
  return (
    <CronoCheckboxWrapper
      icon={<IconUnchecked className="crono-checkbox-icon" />}
      checkedIcon={
        <IconChecked color={colors.mainDark} className="crono-checkbox-icon" />
      }
      indeterminateIcon={
        <IconIndeterminate
          color={colors.mainDark}
          className="crono-checkbox-icon"
        />
      }
      {...props}
      sx={{
        padding: 0,
        margin: 0,
        '&:hover': {
          backgroundColor: colors.grey4,
        },
        '&.Mui-checked': {
          '&:hover': {
            opacity: 0.7,
          },
        },
        marginRight: 1,
        marginLeft: 1,
        opacity: disabled ? 0.5 : 1,
        svg: {
          rect: {
            stroke: colors.grey11,
          },
        },
        ...sx,
      }}
      disabled={disabled}
    />
  );
};

const CronoCheckboxWrapper = styled(Checkbox)`
  .crono-checkbox-icon {
    width: 16px;
    height: 16px;
    overflow: visible;
  }
`;

export default CronoCheckbox;
